<template>
  <div class="content page-content" v-loading="loading">
    <ListButton
      :buttonObj="buttonObj"
      :buttonList="buttonList"
      :selected="selected"
      v-on:clickType="OnCheckList"
      :tagsData="projectOrder.routerParams.orderName"
      :seqList="sepList"
      @create="handleBatchBuildSchedule"
      @deleteTag="handleDeleteTag"
      @popover-save="handlePopoverSave(arguments)"
    ></ListButton>
    <el-row>
      <Table
        :props="table.props"
        ref="table"
        :header="table.header.filter(item => item.isShow === true)"
        :data="table.data"
        :selected="table.selected"
        :selection-type="table.selectionType"
        @row-selection-add="handleRowSelectionAdd"
        @row-selection-remove="handleRowSelectionRemove"
        @all-row-selection-change="handleAllRowSelectionChange"
      />
      <pagination
        v-bind:currentpage="currentPage"
        v-bind:pagesize="pageSize"
        v-bind:totalcount="totalCount"
        @handle-size-change="handleSizeChange"
        @handle-current-change="handleCurrentChange"
      ></pagination>
    </el-row>
    <!--详情-->
    <el-drawer
      :visible.sync="drawer"
      size="60%" :modal="false"
      class="detail-drawer"
      :with-header="false"
      @reload-content="handleReloadContent"
      @open="handleOpenDrawer"
    >
      <Read
        v-if="drawer"
        :scheduleForm="scheduleForm"
        :tabActiveName="drawerTabsActiveName"
        :spaceList="spaceList"
        @edit="handleEdit"
        @closeDrawer="handleCloseDrawer"
        @changeSwitchStatus="changeSwitchStatus"
        @reload-content="handleReloadContent"
      ></Read>
    </el-drawer>
    <el-dialog :visible.sync="copyDialog" width="33%" title="复制计划单" :close-on-click-modal="false" :destroy-on-close="true">
      <el-form ref="copyForm" class="copy-form" :model="copyForm" label-width="80px" label-position="left">
        <el-row>
          <el-col :span="22">
            <el-form-item label="复制份数">
              <el-input-number v-model="copyForm.quantity" :min="1" :max="10" :step="1"></el-input-number>
            </el-form-item>
            <el-form-item label="所属订单">
              <CommonLazySelect
                v-if="copyDialog"
                v-model="copyForm.orderId"
                class="lazy-select"
                :filter="{
                  orderName: '',
                  sellingType: copyForm.sellingType,
                  partnerId: copyForm.partnerId
                }"
                :primaryKey="{ orderId: copyForm.orderId }"
                :optionsMap="{
                  key: 'orderId',
                  label: 'orderName'
                }"
                :extendField="true"
                serviceName="getOrderList"
              ></CommonLazySelect>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="copyDialog = false">取 消</el-button>
        <el-button type="primary" :loading="copyLoading" @click="copySchedule">保 存</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import ListButton from '@/components/ListButton'
import { debounce } from 'lodash'
import Read from './AdServingManageRead'
import InputIconEdit from '@/components/InputIconEdit'
import useSpaceComponent from '@/hooks/useSpaceComponent'
import CommonLazySelect from '@/components/common/CommonLazySelect.vue'

export default {
  components: {
    ListButton,
    Read,
    CommonLazySelect
  },
  inject: ['projectOrder'],
  data() {
    return {
      loading: false,
      spaceList: [],
      buttonObj: {
        fullTitle: '批量建单',
        permissionData: 'schedule:operate'
      },
      buttonList: [
        {
          icon: 'el-icon-plus',
          title: '普通建单',
          number: '5',
          key: 'createSchedule',
          permission: 'schedule:add',
          disabled: false
        },
        {
          icon: 'el-icon-folder-add',
          title: '批量操作',
          key: 'batchOperate',
          permission: 'schedule:operate',
          disabled: false,
          children: [
            {
              icon: 'el-icon-caret-right',
              title: '启用',
              key: 'start',
              permission: 'schedule:operate',
              disabled: true
            },
            {
              icon: 'el-icon-cc-pause',
              title: '暂停',
              key: 'pause',
              permission: 'schedule:operate',
              disabled: true
            },
            {
              icon: 'el-icon-cc-wancheng',
              title: '结束',
              key: 'end',
              permission: 'schedule:operate',
              disabled: true
            },
            {
              icon: 'el-icon-cc-lajitong',
              title: '删除',
              key: 'del',
              permission: 'schedule:operate',
              disabled: true,
              type: 'button'
            },
            {
              icon: 'el-icon-position',
              title: '送审',
              key: 'check',
              permission: 'schedule:operate',
              disabled: true,
              type: 'button'
            },
            {
              icon: 'el-icon-cc-fuben',
              title: '复制',
              key: 'copy',
              permission: 'schedule:operate',
              disabled: true,
              visible: false
            },
            {
              icon: 'el-icon-refresh-left',
              title: '撤回',
              key: 'callback',
              permission: 'schedule:operate',
              disabled: true,
              visible: false
            },
            {
              title: '修改优先级',
              key: 'editSeq',
              permission: 'schedule:operate',
              disabled: true,
              visible: false
            },
            {
              title: '修改投放速度',
              key: 'editSpeed',
              permission: 'schedule:operate',
              disabled: true,
              visible: false
            }
          ]
        }
      ],
      buttonListMethodMaps: {
        start: this.handleStartSchedule,
        pause: this.handlePauseSchedule,
        end: this.handleEndSchedule,
        del: this.handleDelSchedule,
        check: this.handleCheckSchedule,
        copy: this.handleCopySchedule,
        callback: this.handleCallbackSchedule,
        editSeq: this.handleEditSeq,
        editSpeed: this.handleEditSpeed,
        createSchedule: this.handleCreate
      },
      drawer: false,
      detailScheduleId: undefined,
      detailSpaceId: undefined,
      dialogTableVisible: false,
      showClose: false,
      checkTableHeader: [],
      tableHeader: [],
      timeList: '',
      pickerOptions: {
        disabledDate(time) {
          return (
            time.getTime() > Date.now() + 3600 * 1000 * 24 * 28 ||
            time.getTime() < Date.now()
          )
        },
        shortcuts: [
          {
            text: '未来一周',
            onClick(picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() + 3600 * 1000 * 24)
              end.setTime(end.getTime() + 3600 * 1000 * 24 * 7)
              picker.$emit('pick', [start, end])
            }
          },
          {
            text: '未来28天',
            onClick(picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() + 3600 * 1000 * 24)
              end.setTime(end.getTime() + 3600 * 1000 * 24 * 28)
              picker.$emit('pick', [start, end])
            }
          }
        ]
      },
      dataTypeTime: [new Date(2016, 9, 10, 0, 0, 0), new Date(2016, 9, 10, 23, 59, 59)],
      dialogVisible: false,
      dialogTableEditVisible: false,
      clickType: 0, // 表格操作栏点击事件类别
      visible: false,
      pageSize: 10,
      // 当前页码:pageNum
      currentPage: 1,
      totalCount: 1,
      // 查询的页码
      start: 1,
      filter: {},
      table: {
        props: {
          border: true,
          'tooltip-effect': 'dark'
        },
        header: [
          {
            label: '',
            align: 'center',
            fixed: 'left',
            prop: 'scheduleStatus',
            width: 65,
            isShow: this.getTableOpen('schedule:operate'),
            render: (h, { row }) => {
              return h('el-switch', {
                props: {
                  disabled:
                    (row.scheduleStatus !== 3 && row.scheduleStatus !== 4 && row.scheduleStatus !== 9) ||
                    (row.adOrder && row.adOrder.orderStatus === 2),
                  value: row.scheduleStatus === 3 || row.scheduleStatus === 4,
                  width: 28
                },
                on: {
                  input: (value) => {
                    const obj = {
                      ids: [row.scheduleId],
                      operateType: value === true ? 1 : 2
                    }
                    this.$service.operateSchedule(obj).then((data) => {
                      if (data.code === 0) {
                        this.fetchData()
                        this.table.selected = []
                        this.selected = []
                        this.selectedRow = []
                      }
                    })
                  }
                }
              })
            }
          },
          {
            label: '计划单号',
            align: 'left',
            prop: 'scheduleNo',
            fixed: 'left',
            'min-width': 155,
            isShow: true,
            'show-overflow-tooltip': true
          },
          {
            label: '计划名称',
            align: 'left',
            prop: 'scheduleName',
            fixed: 'left',
            'min-width': 320,
            isShow: true,
            'show-overflow-tooltip': true,
            render: (h, { row }) => {
              return h(InputIconEdit, {
                props: {
                  initValue: row.scheduleName,
                  listName: 'schedule',
                  currentTableData: row,
                  permission: 'schedule:edit',
                  disabled:
                    row.scheduleStatus === -1 ||
                    row.scheduleStatus === 5 ||
                    row.scheduleStatus === 11 ||
                    row.scheduleStatus === 6
                },
                on: {
                  confirm: (value) => {
                    this.$service
                      .operate(
                        {
                          ids: [row.scheduleId],
                          operateType: 5,
                          scheduleName: value
                        },
                        '操作成功'
                      )
                      .then((data) => {
                        row.scheduleName = value
                        // this.fetchData()
                      })
                  }
                }
              })
            }
          },
          {
            label: '广告主',
            align: 'left',
            prop: 'adDspPartner.partnerName',
            'min-width': 200,
            isShow: this.projectOrder.accountType === '1',
            'show-overflow-tooltip': true
          },
          {
            label: '状态',
            align: 'left',
            prop: 'scheduleStatus',
            'min-width': 120,
            'show-overflow-tooltip': true,
            isShow: true,
            formatter: (params) => {
              return this.$consts.shceduleStatusText[params.scheduleStatus] || '-'
            }
          },
          {
            label: '投放时间',
            align: 'left',
            prop: 'timeList',
            'min-width': 220,
            isShow: true,
            'show-overflow-tooltip': true,
            render: (h, { row }) => {
              if (row.timeList && row.timeList.length > 0) {
                return (
                  this.$moment(row.timeList[0].beginTime).format('YYYY-MM-DD') +
                  '~' +
                  this.$moment(row.timeList[row.timeList.length - 1].endTime).format(
                    'YYYY-MM-DD'
                  )
                )
              }
            }
          },
          {
            label: '广告位',
            align: 'left',
            prop: 'adSpace.spaceName',
            'min-width': 150,
            isShow: true,
            'show-overflow-tooltip': true
          },
          {
            label: '投放渠道',
            align: 'left',
            prop: 'channelId',
            'min-width': 150,
            isShow: true,
            'show-overflow-tooltip': true,
            formatter: (params) => {
              return this.listTypeText.channelText[params.channelId] || '-'
            }
          },
          {
            label: 'ERP子单号',
            align: 'left',
            prop: 'erpSubOrder',
            'min-width': 150,
            isShow: true,
            'show-overflow-tooltip': true
          },
          {
            label: '子单状态',
            align: 'left',
            prop: 'erpSubOrderStatus',
            'min-width': 150,
            isShow: true,
            'show-overflow-tooltip': true,
            render: (h, { row }) => {
              return ['启用', '暂停'][row.erpSubOrderStatus]
            }
          },
          {
            label: 'ERP订单名称',
            align: 'left',
            prop: 'erpOrderName',
            'min-width': 260,
            isShow: true,
            'show-overflow-tooltip': true
          },
          {
            label: 'ERP产品编码',
            align: 'left',
            prop: 'erpMaterialCode',
            'min-width': 150,
            isShow: true,
            'show-overflow-tooltip': true
          },
          {
            label: 'ERP产品名称',
            align: 'left',
            prop: 'erpMaterialName',
            'min-width': 260,
            isShow: true,
            'show-overflow-tooltip': true
          },
          {
            label: '投放总量(PV)',
            align: 'right',
            prop: 'totalTraffic',
            'min-width': 150,
            isShow: true,
            'show-overflow-tooltip': true,
            formatter: (params) => {
              return (params.freeTotalTraffic + params.payTotalTraffic + params.addedTotalTraffic).toLocaleString()
            }
          },
          {
            label: '排期量(PV)',
            align: 'right',
            prop: 'payTotalTraffic',
            'min-width': 150,
            isShow: true,
            'show-overflow-tooltip': true,
            formatter: (params) => {
              return (params.payTotalTraffic || 0).toLocaleString()
            }
          },
          {
            label: '赠送量(PV)',
            align: 'right',
            prop: 'freeTotalTraffic',
            'min-width': 150,
            isShow: true,
            'show-overflow-tooltip': true,
            formatter: (params) => {
              return (params.freeTotalTraffic || 0).toLocaleString()
            }
          },
          {
            label: '补量(PV)',
            align: 'right',
            prop: 'addedTotalTraffic',
            'min-width': 150,
            isShow: true,
            'show-overflow-tooltip': true,
            formatter: (params) => {
              return (params.addedTotalTraffic || 0).toLocaleString()
            }
          },
          {
            label: '曝光量(PV)',
            align: 'right',
            prop: 'sendAmount',
            'min-width': 150,
            isShow: true,
            'show-overflow-tooltip': true,
            formatter: (params) => {
              return (params.sendAmount || 0).toLocaleString()
            }
          },
          {
            label: '有效素材数',
            align: 'right',
            prop: 'mediaNumber',
            'min-width': 150,
            isShow: true,
            'show-overflow-tooltip': true,
            formatter: (params) => {
              return (params.mediaNumber || 0).toLocaleString()
            }
          },
          {
            label: '优先级',
            align: 'right',
            prop: 'seq',
            'min-width': 150,
            isShow: true,
            'show-overflow-tooltip': true
            // formatter: params => { //优先级都显示数值
            //   return this.listTypeText.seqText[params.seq] || '自动'
            // }
          },
          {
            label: '投放方式',
            align: 'left',
            prop: 'trafficType',
            'min-width': 150,
            isShow: true,
            'show-overflow-tooltip': true,
            formatter: (params) => {
              if (params.trafficType || params.trafficType === 1) {
                return this.$consts.trafficTypeText[params.trafficType] || '-'
              } else {
                return '-'
              }
            }
          },
          {
            label: '销售方式',
            align: 'left',
            prop: 'saleType',
            'min-width': 150,
            isShow: true,
            'show-overflow-tooltip': true,
            formatter: (params) => {
              return this.listTypeText.saleTypeText[params.saleType] || '-'
            }
          },
          {
            label: '结算方式',
            align: 'left',
            prop: 'payment',
            'min-width': 150,
            isShow: true,
            'show-overflow-tooltip': true,
            formatter: (params) => {
              if (Object.keys(this.listTypeText.payMentText).length > 0) {
                return this.listTypeText.payMentText[params.payment] || '-'
              } else {
                return '-'
              }
            }
          },
          {
            label: '程序化来源',
            align: 'left',
            prop: 'scheduleSource',
            'min-width': 150,
            isShow: true,
            'show-overflow-tooltip': true,
            formatter: (params) => {
              if (Object.keys(this.listTypeText.scheduleSourceText).length > 0) {
                return this.listTypeText.scheduleSourceText[params.scheduleSource] || '-'
              } else {
                return '-'
              }
            }
          },
          {
            label: '程序化类型',
            align: 'left',
            prop: 'supportMode',
            'min-width': 150,
            isShow: true,
            'show-overflow-tooltip': true,
            formatter: (params) => {
              return this.$consts.supportModeTypeText[params.supportMode] || '-'
            }
          },
          {
            label: '投放速度',
            align: 'left',
            prop: 'trafficSpeed',
            'min-width': 150,
            isShow: true,
            'show-overflow-tooltip': true,
            formatter: (params) => {
              const type = ['-', '快速投放', '匀速投放', '智能投放']
              if (params.trafficSpeed || params.trafficSpeed === 0) {
                return type[params.trafficSpeed]
              } else {
                return '-'
              }
            }
          },
          {
            label: '售卖价格',
            align: 'right',
            prop: 'sellingPrice',
            'min-width': 150,
            isShow: true,
            'show-overflow-tooltip': true,
            formatter: (params) => {
              const sellingPrice = parseFloat(params.sellingPrice || 0)
              const billType = params.billType === 1 ? 'CPM' : 'CPD'
              return `${sellingPrice} 元/${billType}`
            }
          },
          {
            label: '创建时间',
            align: 'left',
            prop: 'createTime',
            'min-width': 200,
            isShow: true,
            'show-overflow-tooltip': true,
            render: (h, { row }) => {
              return h('TimeFormat', {
                props: {
                  value: row.createTime
                }
              })
            }
          },
          {
            label: '所属订单编号',
            align: 'left',
            prop: 'adOrder.orderNo',
            'min-width': 150,
            isShow: true,
            'show-overflow-tooltip': true
          },
          {
            label: '所属订单名称',
            align: 'left',
            prop: 'adOrder.orderName',
            isShow: true,
            'min-width': 220,
            'show-overflow-tooltip': true
          },
          {
            label: 'ID',
            align: 'right',
            prop: 'scheduleId',
            'min-width': 150,
            isShow: true,
            'show-overflow-tooltip': true
          },
          {
            label: '操作栏',
            align: 'left',
            'min-width': 190,
            isShow: true,
            fixed: 'right',
            render: (h, { row }) => {
              const scheduleStatus = row.scheduleStatus
              const disabled =
                scheduleStatus === -1 ||
                scheduleStatus === 5 ||
                scheduleStatus === 11 ||
                scheduleStatus === 6
              return h('div', [
                h(
                  'el-button',
                  {
                    props: {
                      type: 'text',
                      disabled
                    },
                    class: 'el-table-button-text',
                    on: {
                      click: (event) => {
                        event.stopPropagation()
                        this.handleEdit(row)
                      }
                    },
                    directives: [
                      {
                        name: 'permission',
                        value: 'schedule:edit'
                      }
                    ]
                  },
                  '编辑'
                ),
                h(
                  'el-button',
                  {
                    props: {
                      type: 'text'
                    },
                    class: 'el-table-button-text',
                    on: {
                      click: (event) => {
                        event.stopPropagation()
                        this.handleRead(row)
                      }
                    },
                    directives: [
                      {
                        name: 'permission',
                        value: 'schedule:dataOne'
                      }
                    ]
                  },
                  '详情'
                ),
                h(
                  'el-button',
                  {
                    props: {
                      type: 'text'
                    },
                    class: 'el-table-button-text',
                    on: {
                      click: (event) => {
                        event.stopPropagation()
                        this.handleCopy(row)
                      }
                    },
                    directives: [
                      {
                        name: 'permission',
                        value: 'schedule:copy'
                      }
                    ]
                  },
                  '复制'
                ),
                h(
                  'el-dropdown',
                  {
                    props: {
                      trigger: 'click'
                    },
                    style: {
                      'margin-left': '10px'
                    },
                    on: {
                      command: (event) => {
                        this.handleCommand(row, event)
                      }
                    }
                  },
                  [
                    h('span', {
                      class: 'el-icon-more',
                      style: {
                        color: '#1890FF',
                        lineHeight: '24px',
                        cursor: 'pointer',
                        transform: 'rotate(90deg)'
                      }
                    }),
                    h(
                      'el-dropdown-menu',
                      {
                        slot: 'dropdown',
                        style: {
                          'width': '120px'
                        }
                      },
                      [
                        h(
                          'el-dropdown-item',
                          {
                            props: {
                              command: 'data'
                            },
                            directives: [
                              {
                                name: 'permission',
                                value: 'schedule:data'
                              }
                            ]
                          },
                          '数据'
                        ),
                        h(
                          'el-dropdown-item',
                          {
                            props: {
                              command: 'log'
                            },
                            directives: [
                              {
                                name: 'permission',
                                value: 'schedule:log'
                              }
                            ]
                          },
                          '日志'
                        ),
                        h(
                          'el-dropdown-item',
                          {
                            props: {
                              command: 'delete'
                            },
                            directives: [
                              {
                                name: 'permission',
                                value: 'schedule:operate'
                              }
                            ]
                          },
                          '删除'
                        )
                      ]
                    )
                  ]
                )
              ])
            }
          }
        ],
        data: [],
        selected: [],
        selectionType: 'multiple'
      },
      selected: [],
      selectedRow: [],
      scheduleForm: {
        adOrder: {},
        scheduleId: '',
        partnerName: '',
        scheduleName: '',
        scheduleNo: '',
        spaceName: '',
        scheduleStatus: '',
        scheduleIng: '',
        projectName: '',
        planType: '',
        saleType: '',
        channelId: '',
        payment: '',
        settlementProvider: '',
        settlementType: '',
        seq: '',
        trafficSpeed: '',
        scheduleUnionList: [],
        timeList: [],
        dailyTrafficList: [],
        totalTraffic: '',
        trafficType: '',
        trafficDaily: '',
        frequency: 1,
        scheduleCableChannels: [],
        logData: [],
        uvPercentage: '',
        uvTarget: '',
        taCondition: '',
        autoAddName: '',
        uaTaLabel: '',
        kpiLabel: '',
        pvRatioType: 0,
        uvRateList: [],
        uvRateStr: []
      },
      drawerTabsActiveName: 'detail',
      listTypeText: {
        seqText: {},
        payMentText: {},
        scheduleSourceText: {},
        channelText: {},
        saleTypeText: {}
      },
      copyDialog: false,
      copyLoading: false,
      copyForm: {
        quantity: 1,
        orderId: undefined,
        scheduleId: undefined,
        sellingType: undefined,
        partnerId: undefined
      },
      sepList: [] // 批量操作修改优先级
    }
  },
  watch: {
    'projectOrder.selectForm': {
      handler(newVal, oldVal) {
        this.currentPage = 1
        this.pageSize = 10
        this.table.selected = []
        this.selected = []
        this.selectedRow = []
        this.fetchDataDebounced()
      }
    },
    'projectOrder.searchParam'(newValue, oldValue) {
      this.currentPage = 1
      this.pageSize = 10
      this.selected = []
      this.table.selected = []
      this.selectedRow = []
    },
    'projectOrder.timeList': {
      handler() {
        this.fetchData()
      }
    },
    selected: {
      handler(newValue, oldValue) {
        const self = this
        this.buttonList
          .filter((item) => item.children && item.children.length > 0)
          .forEach((e) => {
            e.children.forEach((child) => {
              child.disabled = newValue.length === 0
              if (child.key === 'start') {
                const startDisabled = newValue.some(id => {
                  const shceduleRow = self.table.data.find(schedule => schedule.scheduleId === id)
                  const orderStatus = shceduleRow ? shceduleRow.adOrder.orderStatus : 0
                  return orderStatus === 2
                })
                child.disabled = startDisabled
              }
            })
          })
      }
    }
  },
  methods: {
    getTableOpen(value) {
      if (this.$appState.$get('permissions')[value]) {
        return true
      } else {
        return false
      }
    },
    getBaseDict() {
      this.$service.getBaseDict().then((data) => {
        this.sepList = data.seqList || []
        this.listTypeText.seqText = data.seqList.reduce((result, item) => {
          result[item.dictValue] = item.dictLabel
          return result
        }, {})
        this.listTypeText.payMentText = data.paymentList.reduce((result, item) => {
          result[item.dictValue] = item.dictLabel
          return result
        }, {})
        this.listTypeText.scheduleSourceText = data.scheduleSourceList.reduce(
          (result, item) => {
            if (item.bizValue === 0) {
              result[item.bizValue] = '-'
            } else {
              result[item.bizValue] = item.bizLabel
            }
            return result
          },
          {}
        )
        this.listTypeText.channelText = data.channelIdList.reduce((reslut, item) => {
          reslut[item.channelId] = item.channelName
          return reslut
        }, {})
        this.listTypeText.saleTypeText = data.saleTypeList.reduce((res, item) => {
          res[item.bizValue] = item.bizLabel
          return res
        }, {})
      })
    },
    fetchData() {
      this.loading = true
      this.filter.pageNo = this.currentPage
      this.filter.pageSize = this.pageSize
      // 计划状态
      this.filter.scheduleStatus = this.projectOrder.selectForm.scheduleStatus
        ? this.projectOrder.selectForm.scheduleStatus
        : undefined
      this.filter.orderId = this.projectOrder.routerParams.orderId
        ? this.projectOrder.routerParams.orderId
        : undefined
      this.filter.spaceId = this.projectOrder.selectForm.scheduleSpaceId
        ? this.projectOrder.selectForm.scheduleSpaceId
        : undefined
      this.filter.partnerName = this.projectOrder.selectForm.schedulePartnerName
        ? this.projectOrder.selectForm.schedulePartnerName
        : undefined
      this.filter.erpSubOrder = this.projectOrder.selectForm.erpSubOrder || undefined
      this.filter.erpSubOrderStatus = this.projectOrder.selectForm.erpSubOrderStatus === '' ? undefined : this.projectOrder.selectForm.erpSubOrderStatus
      this.filter.erpMaterialCode = this.projectOrder.selectForm.erpMaterialCode || undefined
      this.filter.suborderNo = this.projectOrder.selectForm.suborderNo || undefined
      // 投放时间
      if (this.projectOrder.selectForm.putTime) {
        this.filter.startDateX = this.$moment(
          this.projectOrder.selectForm.putTime[0]
        ).format('YYYY-MM-DD 00:00:00')
        this.filter.endDateX = this.$moment(
          this.projectOrder.selectForm.putTime[1]
        ).format('YYYY-MM-DD 23:59:59')
      } else {
        if (this.projectOrder.timeList) {
          this.filter.startDateX = this.$moment(this.projectOrder.timeList[0]).format(
            'YYYY-MM-DD 00:00:00'
          )
          this.filter.endDateX = this.$moment(this.projectOrder.timeList[1]).format(
            'YYYY-MM-DD 23:59:59'
          )
        } else {
          this.filter.startDateX = undefined
          this.filter.endDateX = undefined
        }
      }
      // 检索订单名称或单号的计划单
      if (this.projectOrder.selectNameType === 0) {
        // 如果不存在订单名称，并且当前的查询名字是订单
        this.filter.searchParam = this.projectOrder.searchParam // 查询订单
      } else {
        this.filter.searchParam = undefined
      }
      // 检索计划名称或单号
      if (this.projectOrder.selectNameType === 1) {
        this.filter.searchScheduleParam = this.projectOrder.searchParam
          ? this.projectOrder.searchParam
          : undefined
      } else {
        this.filter.searchScheduleParam = undefined
      }
      // 销售方式
      this.filter.saleType =
        this.projectOrder.selectForm.saleType !== ''
          ? this.projectOrder.selectForm.saleType
          : undefined
      // 结算方式
      this.filter.payment =
        this.projectOrder.selectForm.payment !== ''
          ? this.projectOrder.selectForm.payment
          : undefined
      // 程序化来源
      this.filter.scheduleSource =
        this.projectOrder.selectForm.scheduleSource !== ''
          ? this.projectOrder.selectForm.scheduleSource
          : undefined
      // 程序化类型
      this.filter.supportMode =
        this.projectOrder.selectForm.supportMode !== ''
          ? this.projectOrder.selectForm.supportMode
          : undefined
      this.$service
        .getScheduleList(this.filter)
        .then((data) => {
          this.loading = false
          this.totalCount = data.total
          this.$nextTick(() => {
            this.table.data = data.rows || []
            this.updateTableSelected()
          })
        })
        .catch((e) => {
          this.loading = false
        })
    },
    handleCreate() {
      this.$emit('create')
    },
    handleEdit(row) {
      this.drawer = false
      this.$emit('edit', row)
    },
    handleRead(row) {
      this.detailScheduleId = row.scheduleId
      this.detailSpaceId = row.spaceId
      this.drawer = true
      this.drawerTabsActiveName = 'detail'
    },
    handleCopy(row) {
      this.copyForm.scheduleId = row.scheduleId
      this.copyForm.orderId = row.orderId
      this.copyForm.quantity = 1
      this.copyForm.sellingType = row.billType
      this.copyForm.partnerId = row.partnerId
      this.copyDialog = true
    },
    async copySchedule() {
      const isValid = this.$refs.copyForm.validate().catch(() => {})
      if (!isValid) return
      const params = {
        orderId: this.copyForm.orderId,
        scheduleId: this.copyForm.scheduleId,
        quantity: this.copyForm.quantity
      }
      this.copyLoading = true
      this.$service
        .copySchedule(params, '操作成功')
        .then((data) => {
          this.copyLoading = false
          this.copyDialog = false
          this.fetchData()
        })
        .catch(() => {
          this.copyLoading = false
        })
    },
    handleDeleteTag() {
      this.projectOrder.searchParam = ''
      this.projectOrder.routerParams.orderName = ''
      this.projectOrder.routerParams.orderId = ''
      this.$router.push({
        name: 'projectOrder'
      })
    },
    showPopover(type) {
      this.clickType = type
      this.dialogVisible = true
    },
    handleTbaleData(type) {
      this.showPopover(type)
    },
    OnSubmit() {
      let obj = {
        ids: this.selected,
        operateType: parseInt(this.clickType)
      }
      if (this.clickType === '6') {
        obj.beginDate = this.$moment(this.timeList[0]).format('YYYY-MM-DD')
        obj.endDate = this.$moment(this.timeList[1]).format('YYYY-MM-DD')
      }
      if (this.clickType === '7') {
        obj.beginTime = this.$moment(this.dataTypeTime[0]).format('HH:mm:ss')
        obj.endTime = this.$moment(this.dataTypeTime[1]).format('HH:mm:ss')
      }
      this.$service.operate(obj, '操作成功').then((data) => {
        this.selected = []
        this.table.selected = []
        this.fetchData()
        this.dialogVisible = false
        this.timeList = ''
        this.dataTypeTime = [
          new Date(2016, 9, 10, 0, 0, 0),
          new Date(2016, 9, 10, 23, 59, 59)
        ]
      })
    },
    OnCheckList(value) {
      this.buttonListMethodMaps[value]()
    },
    handlePopoverSave(data) {
      const operateType = data[1].key
      this.buttonListMethodMaps[operateType](data[0])
    },
    // 启用 只能启用暂停状态的： 9
    handleStartSchedule(val) {
      const result = this.selectedRow
        .filter((item) => item.scheduleStatus === 9)
        .map((e) => e.scheduleId)
      if (result.length > 0) {
        const obj = {
          operateType: 1,
          ids: result,
          executeType: val.startTimeType,
          executeTime:
            val.startTimeType === 1
              ? this.$moment(new Date()).format('YYYY-MM-DD HH:mm:ss')
              : this.$moment(val.startTime).format('YYYY-MM-DD HH:mm:ss')
        }
        this.$service.operateSchedule(obj).then((data) => {
          if (data.code === 0) {
            this.$message.success('已为您启用' + result.length + '条计划')
            this.table.selected = []
            this.selected = []
            this.selectedRow = []
            this.fetchData()
          } else {
            this.$message.error('启用失败，请重试')
          }
        })
      } else {
        this.$message('没有符合启用条件的计划单')
      }
    },
    // 暂停 只能暂停待投放: 3,投放中：4
    handlePauseSchedule(val) {
      const result = this.selectedRow
        .filter((item) => item.scheduleStatus === 3 || item.scheduleStatus === 4)
        .map((e) => e.scheduleId)
      if (result.length > 0) {
        const obj = {
          operateType: 2,
          ids: result,
          executeType: val.pauseTimeType,
          executeTime:
            val.pauseTimeType === 1
              ? this.$moment(new Date()).format('YYYY-MM-DD HH:mm:ss')
              : this.$moment(val.pauseTime).format('YYYY-MM-DD HH:mm:ss')
        }
        this.$service.operate(obj).then((data) => {
          if (data.code === 0) {
            this.$message.success('已为您暂停' + result.length + '条计划单')
            this.table.selected = []
            this.selected = []
            this.selectedRow = []
            setTimeout(() => {
              this.fetchData()
            }, 400)
          } else {
            this.$message.error('暂停失败，请重试')
          }
        })
      } else {
        this.$message('没有符合暂停条件的计划单')
      }
    },
    // 结束 只能结束 待投放、投放中和暂停的（3，4，9）
    handleEndSchedule(val) {
      const result = this.selectedRow
        .filter((item) => item.scheduleStatus === 4 || item.scheduleStatus === 9 || item.scheduleStatus === 3)
        .map((e) => e.scheduleId)
      if (result.length > 0) {
        const obj = {
          operateType: 3,
          ids: result,
          executeType: val.endTimeType,
          executeTime:
            val.endTimeType === 1
              ? this.$moment(new Date()).format('YYYY-MM-DD HH:mm:ss')
              : this.$moment(val.endTime).format('YYYY-MM-DD HH:mm:ss')
        }
        this.$service.operate(obj).then((data) => {
          if (data.code === 0) {
            this.$message.success('已为您结束' + result.length + '条计划单')
            this.table.selected = []
            this.selected = []
            this.selectedRow = []
            setTimeout(() => {
              this.fetchData()
            }, 400)
          } else {
            this.$message.error('结束失败，请重试')
          }
        })
      } else {
        this.$message('没有符合结束的计划单')
      }
    },
    // 删除 只有草稿的: 1可以删除
    handleDelSchedule() {
      const result = this.selectedRow
        .filter((item) => item.scheduleStatus === 1)
        .map((e) => e.scheduleId)
      if (result.length > 0) {
        this.$confirm('确定是否删除', '提示', {
          confirmButtonClass: 'normal-btn-orange',
          confirmButtonText: '确定',
          cancelButtonClass: 'normal-btn-cancel',
          cancelButtonText: '取消',
          showClose: false,
          center: true
        }).then(() => {
          const obj = {
            ids: result,
            operateType: 4
          }
          this.$service.operate(obj).then((data) => {
            if (data.code === 0) {
              this.$message.success('已为您删除' + result.length + '条计划')
              this.table.selected = []
              this.selected = []
              this.selectedRow = []
              this.fetchData()
            } else {
              this.$message.error('删除失败，请重试')
            }
          })
        })
      } else {
        this.$message('没有符合删除的计划单')
      }
    },
    // 送审 只能送审草稿：1
    handleCheckSchedule() {
      const result = this.selectedRow
        .filter((item) => item.scheduleStatus === 1 || item.scheduleStatus === 9)
        .map((e) => e.scheduleId)
      if (result.length > 0) {
        const obj = {
          operateType: 6,
          ids: result
        }
        this.$service.operate(obj).then((data) => {
          if (data.code === 0) {
            this.$message.success('成功送审' + result.length + '条计划单')
            this.table.selected = []
            this.selected = []
            this.selectedRow = []
            this.fetchData()
          } else {
            this.$message.error('送审失败，请重试')
          }
        })
      } else {
        this.$message('所选计划单中无草稿状态，送审失败')
      }
    },
    // 复制 任意状态可复制，复制后的副本是草稿
    handleCopySchedule(val) {
      const result = this.selectedRow.map((item) => item.scheduleId)
      const obj = {
        operateType: 7,
        ids: result,
        copyNum: val.copyNum
      }
      this.$service.operate(obj).then((data) => {
        if (data.code === 0) {
          this.table.selected = []
          this.selected = []
          this.selectedRow = []
          this.fetchData()
          this.$message.success('成功复制' + val.copyNum + '条计划单')
        } else {
          this.$message.error('复制失败，请重试')
        }
      })
    },
    // 撤回 只能撤回待审核:2
    handleCallbackSchedule(val) {
      const result = this.selectedRow
        .filter((item) => item.scheduleStatus === 2)
        .map((e) => e.scheduleId)
      if (result.length > 0) {
        const obj = {
          operateType: 8,
          ids: result
        }
        this.$service.operate(obj).then((data) => {
          if (data.code === 0) {
            this.table.selected = []
            this.selected = []
            this.selectedRow = []
            this.fetchData()
            this.$message.success('成功撤回' + result.length + '条计划单')
          } else {
            this.$message.error('撤回失败，请重试')
          }
        })
      } else {
        this.$message('没有符合撤回的计划单')
      }
    },
    // 修改优先级  默认优先级立即生效
    handleEditSeq(val) {
      const result = this.selectedRow.map((item) => item.scheduleId)
      const obj = {
        operateType: 9,
        ids: result,
        updateType: val.seqType,
        priority: val.seqType === 1 ? val.seq : undefined,
        executeType: val.seqTimeType,
        executeTime:
          val.seqTimeType === 1
            ? this.$moment(new Date()).format('YYYY-MM-DD HH:mm:ss')
            : this.$moment(val.seqTime).format('YYYY-MM-DD HH:mm:ss')
      }
      this.$service.operate(obj).then((data) => {
        if (data.code === 0) {
          this.table.selected = []
          this.selected = []
          this.selectedRow = []
          this.fetchData()
          this.$message.success('成功提交' + result.length + '条优先级修改')
        } else {
          this.$message.error('修改失败，请重试')
        }
      })
    },
    // 修改投放速度
    handleEditSpeed(val) {
      const result = this.selectedRow.map((item) => item.scheduleId)
      const obj = {
        operateType: 10,
        ids: result,
        trafficSpeed: val.trafficSpeed,
        executeType: val.trafficTimeType,
        executeTime:
          val.trafficTimeType === 1
            ? this.$moment(new Date()).format('YYYY-MM-DD HH:mm:ss')
            : this.$moment(val.trafficTime).format('YYYY-MM-DD HH:mm:ss')
      }
      this.$service.operate(obj).then((data) => {
        if (data.code === 0) {
          this.table.selected = []
          this.selected = []
          this.selectedRow = []
          this.fetchData()
          this.$message.success('成功提交' + result.length + '条投放速度修改')
        } else {
          this.$message.error('修改失败，请重试')
        }
      })
    },
    // 批量建单
    handleBatchBuildSchedule() {
      this.$router.push({
        name: 'batchOrder'
      })
    },

    handleChangeTableHeader(e) {
      e.isCheck = !e.isCheck
      let index = this.table.header.findIndex((item) => item.label === e.label)
      this.table.header[index].isShow = e.isCheck
      this.$store.commit('saveScheduleTable', this.table.header)
    },
    // 表格操作
    handleRefresh() {
      this.currentPage = 1
      this.filter = {}
      this.fetchData()
    },
    // 每页显示数据量变更, 如每页显示10条变成每页显示20时,val=20
    handleSizeChange(val) {
      this.pageSize = val
      this.fetchData()
    },
    // 页码变更, 如第1页变成第2页时,val=2
    handleCurrentChange(val) {
      this.currentPage = val
      this.fetchData()
    },
    handleRowSelectionAdd(targetItem) {
      this.selected.push(targetItem.scheduleId)
      this.selectedRow.push(targetItem)
      this.updateTableSelected()
    },
    handleRowSelectionRemove(targetItem) {
      this.selected = this.selected.filter((item) => {
        return item !== targetItem.scheduleId
      })
      this.selectedRow = this.selectedRow.filter((item) => {
        return item.scheduleId !== targetItem.scheduleId
      })
      this.updateTableSelected()
    },
    handleAllRowSelectionChange(value) {
      if (value) {
        this.table.data.forEach(this.handleRowSelectionAdd)
      } else {
        this.selected = []
        this.selectedRow = []
        this.table.selected = []
      }
    },
    handleAllRowSelectionRemove() {
      this.selected = []
      this.table.selected = []
      this.selectedRow = []
    },
    updateTableSelected() {
      const table = this.table
      const newSelectedIndex = this.selected
      table.selected = table.data.reduce((result, item, index) => {
        if (newSelectedIndex.indexOf(item.scheduleId) > -1) {
          result.push(index)
        }
        return result
      }, [])
    },
    handleFilterChange(type, filter) {
      if (filter) {
        this.filter = filter
      }
      if (type === 'query') {
        this.pagination.currentPage = 1
      }
      this.fetchData()
    },
    handleCommand(e, command) {
      if (command === 'log') {
        this.detailScheduleId = e.scheduleId
        this.drawer = true
        this.drawerTabsActiveName = 'log'
        // this.handleRead(e)
      } else if (command === 'delete') {
        if (e.scheduleStatus === 1) {
          this.$confirm('确定是否删除', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            showClose: false,
            center: true
          })
            .then(() => {
              const obj = {
                ids: [e.scheduleId],
                operateType: 4 // 删除
              }
              this.$service.operate(obj).then((data) => {
                this.$message.success('已为您删除1条计划')
                this.fetchData()
                this.table.selected = []
                this.selected = []
              })
            })
            .catch(() => {})
        } else {
          this.$message.error('只有草稿状态的计划可以删除')
        }
      } else {
        this.detailScheduleId = e.scheduleId
        this.drawer = true
        this.drawerTabsActiveName = 'dataCharts'
      }
    },
    handleOpenDrawer() {
      const { getComponentsDetail } = useSpaceComponent()
      this.scheduleForm.spaceId = this.detailSpaceId
      this.$service
        .getScheduleDetail({ scheduleId: this.detailScheduleId })
        .then((data) => {
          this.scheduleForm.scheduleId = this.detailScheduleId
          this.scheduleForm.adOrder = data.adOrder
          this.scheduleForm.projectName = data.adProject ? data.adProject.projectName : '-'
          this.scheduleForm.scheduleName = data.scheduleName
          this.scheduleForm.scheduleNo = data.scheduleNo
          this.scheduleForm.seq = data.seq
          this.scheduleForm.trafficSpeed = this.$consts.trafficSpeedTypeText[data.trafficSpeed]
          this.scheduleForm.spaceName = data.adSpace.spaceName
          this.scheduleForm.timeList = data.timeList
          this.scheduleForm.dailyTrafficList = data.dailyTrafficList
          this.scheduleForm.totalTraffic = data.totalTraffic
          // 历史的排期总量 = 投放总量
          this.scheduleForm.payTotalTraffic = data.payTotalTraffic === undefined ? data.totalTraffic : data.payTotalTraffic
          this.scheduleForm.freeTotalTraffic = data.freeTotalTraffic || 0
          this.scheduleForm.addedTotalTraffic = data.addedTotalTraffic || 0
          this.scheduleForm.trafficType = data.trafficType
          this.scheduleForm.trafficDaily = data.trafficDaily
          this.scheduleForm.frequency = data.frequency
          this.scheduleForm.subFrequency = data.subFrequency
          this.scheduleForm.subTrafficDaily = data.subTrafficDaily
          this.scheduleForm.scheduleStatus = data.scheduleStatus
          this.scheduleForm.planType = this.$consts.planTypeText[data.planType]
          this.scheduleForm.saleType = this.listTypeText.saleTypeText[data.saleType] || '-'
          this.scheduleForm.scheduleSource = data.scheduleSource
          this.scheduleForm.scheduleSourceText = this.listTypeText.scheduleSourceText[data.scheduleSource] || '-'
          this.scheduleForm.supportMode = this.$consts.supportModeTypeText[data.supportMode] || '-'
          this.scheduleForm.payment = this.listTypeText.payMentText[data.payment]
          this.scheduleForm.channelId = this.listTypeText.channelText[data.channelId] || '-'
          this.scheduleForm.settlementProvider = data.settlementProvider || ''
          this.scheduleForm.settlementType = data.settlementType
          this.scheduleForm.homeDeWeight = data.homeDeWeight === 0 ? '否' : '是'
          this.scheduleForm.autoFilling = data.autoFilling === 0 ? '是' : '否'
          this.scheduleForm.pvRateName = data.pvRateName
          this.scheduleForm.exposurePct = data.exposurePct
          this.scheduleForm.uvRateList = data.uvRateList || []
          this.scheduleForm.iesSwitch = data.iesSwitch
          if (data.uvRateList && data.uvRateList.length) {
            this.scheduleForm.pvRatioType = 1
          }
          this.scheduleForm.ctr = data.ctr
          if (data.scheduleSub) {
            this.scheduleForm.exposureDirectly = data.scheduleSub.exposureDirectly
            this.scheduleForm.recId = data.scheduleSub.recId
            this.scheduleForm.recName = data.scheduleSub.recName
            this.scheduleForm.checkExposurePct = data.scheduleSub.checkExposurePct
            this.scheduleForm.addExposurePct = data.scheduleSub.addExposurePct
          }
          if (data.scheduleTaUv) {
            this.scheduleForm.uvPercentage = data.scheduleTaUv.uvPercentage
            this.scheduleForm.uvTarget = data.scheduleTaUv.uvTarget
            this.scheduleForm.taCondition = data.scheduleTaUv.taCondition
            if (data.scheduleTaUv.uvTarget && data.scheduleTaUv.uvPercentage) {
              this.scheduleForm.uaTaLabel = data.scheduleTaUv.uvTarget + '+UV大于' + data.scheduleTaUv.uvPercentage + '% '
            } else {
              this.scheduleForm.uaTaLabel = ''
            }
            let kpiLabel = []
            if (data.scheduleTaUv && data.scheduleTaUv.uvStatus) {
              kpiLabel.push('N+UV')
            }
            if (data.scheduleTaUv && data.scheduleTaUv.taStatus) {
              kpiLabel.push('TA')
            }
            this.scheduleForm.kpiLabel = kpiLabel.length ? kpiLabel.join() : '无'
            if (data.scheduleTaUv.uvRateStr) {
              this.scheduleForm.uvRateStr = JSON.parse(data.scheduleTaUv.uvRateStr || '[]')
            } else {
              this.scheduleForm.uvRateStr = []
            }
          } else {
            this.scheduleForm.uvRateStr = []
            this.scheduleForm.kpiLabel = '无'
            this.scheduleForm.uaTaLabel = ''
            this.scheduleForm.taCondition = ''
          }
          // 地区
          this.scheduleForm.adScheduleRegions = (data.adScheduleRegions || []).map((item) => item.name)
          // 尺寸定向
          this.scheduleForm.adScheduleDeviceSizes = (data.adScheduleDeviceSizes || [])
            .map((item) => {
              return item.beginSize + '-' + item.endSize
            })
            .join()
          this.scheduleForm.customMatchRule = data.customMatchRule || 'in'
          // mac标签
          this.scheduleForm.customTagList = (data.customTagList || []).map((item) => item.adCustomTagName)
          // 机型标签
          this.scheduleForm.tagCustomTagList = (data.tagCustomTagList || []).map((item) => item.adCustomTagName)
          // lbs标签
          this.scheduleForm.lbsTagsList = (data.lbsTagsList || []).map((item) => item.circleName)
          // 品牌(1000-2000) 机型(5000-6000、80000-90000)
          this.scheduleForm.adTagDeviceList = (data.adTagDeviceList || [])
            .filter((item) => item.tagDeviceId < 6000 || item.tagDeviceId >= 7000)
            .map((item) => item.tag)
          // 视频源定向(6000-7000)
          this.scheduleForm.videoDeviceList = (data.adTagDeviceList || [])
            .filter((item) => item.tagDeviceId >= 6000 && item.tagDeviceId < 7000)
            .map((item) => item.tag)
          // dmp
          this.scheduleForm.adScheduleDmps = (data.adScheduleDmps || []).map((item) => {
            return {
              text: item.text,
              matchType: item.matchType
            }
          })
          this.scheduleForm.dmpMatchType =
            data.adScheduleDmps.length > 0 ? data.adScheduleDmps[0].matchType : undefined
          this.scheduleForm.adScheduleVideoTags = data.adScheduleVideoTags
          // 广告DMP
          this.scheduleForm.crowdList = (data.adScheduleCrowds || []).map((item) => {
            return {
              text: item.crowdName,
              matchType: item.matchType
            }
          })
          this.scheduleForm.crowdMatchType = data.crowdMatchType || -1
          // 业务定向
          this.scheduleForm.adScheduleBusinessSettings = getComponentsDetail(
            data.componentList,
            data.adScheduleBusinessSettings
          )
          // 三方dmp定向
          this.scheduleForm.thirdDmpEntityList = getComponentsDetail(data.dmpComponentList, data.thirdDmpEntityList)
          this.scheduleForm.adScheduleRegionDailys = data.adScheduleRegionDailys
          this.scheduleForm.payDailyTraffics = (data.payDailyTraffics || []).reduce((prev, cur) => {
            prev[cur.daily] = cur.totalTraffic
            return prev
          }, {}) || {}
          this.scheduleForm.payDailyTraffic = this.getTotalTraffic(this.scheduleForm.payDailyTraffics)
          this.scheduleForm.freeDailyTraffics = (data.freeDailyTraffics || []).reduce((prev, cur) => {
            prev[cur.daily] = cur.totalTraffic
            return prev
          }, {}) || {}
          this.scheduleForm.freeDailyTraffic = this.getTotalTraffic(this.scheduleForm.freeDailyTraffics)
          this.scheduleForm.addedDailyTraffics = (data.addedDailyTraffics || []).reduce((prev, cur) => {
            prev[cur.daily] = cur.totalTraffic
            return prev
          }, {}) || {}
          this.scheduleForm.addedDailyTraffic = this.getTotalTraffic(this.scheduleForm.addedDailyTraffics)
          this.scheduleForm.adScheduleMacs = (data.adScheduleMacs || []).map((item) => {
            return {
              beginMac: item.beginMac,
              endMac: item.endMac
            }
          })
          this.scheduleForm.logData = data.adScheduleLogs
          this.adScheduleModifiedLogs = data.adScheduleModifiedLogs
          // 关联频控
          this.scheduleForm.unionSequence = data.unionSequence
          this.scheduleForm.scheduleUnionList = data.scheduleUnionList || []
          this.scheduleForm.unionFreq = data.unionFreq || 1
          this.scheduleForm.subUnionFreq = data.subUnionFreq || 1
          // 媒体方
          this.scheduleForm.scheduleCableChannels = data.scheduleCableChannels || []
          // 售卖价格
          this.scheduleForm.sellingPrice = data.sellingPrice || 0.0
          this.scheduleForm.billType = data.billType
          this.scheduleForm.receivePct = data.receivePct
          this.scheduleForm.sendPct = data.sendPct
          this.scheduleForm.dealId = data.dealId
          if (data.extendParamsList && data.extendParamsList.length > 0) {
            this.scheduleForm.extendParam = JSON.parse(data.extendParamsList[0].extendParams).paramsArray || []
          }
          // erp订单信息
          this.scheduleForm.erpSubOrderModel = data.erpSubOrderModel
          this.scheduleForm.salesSuborderModel = data.salesSuborderModel
        })
    },
    getTotalTraffic(trfficObj) {
      let total = 0
      Object.keys(trfficObj).forEach(key => {
        total += trfficObj[key]
      })
      return total
    },
    handleCloseDrawer() {
      this.drawer = false
    },
    changeSwitchStatus(data) {
      const obj = {
        ids: [this.detailScheduleId],
        operateType: data === true ? 1 : 2
      }
      this.$service.operate(obj, '操作成功').then((data) => {
        this.fetchData()
      })
    },
    handleReloadContent() {
      this.fetchData()
      this.handleOpenDrawer()
    },
    getSpaceList() {
      this.$service.getEnableSpace({}).then(data => {
        this.spaceList = (data.spaceList || []).map(item => {
          return {
            label: item.spaceName,
            value: item.spaceId,
            spaceNo: item.spaceNo
          }
        })
      })
    }
  },
  created() {
    this.table.data = []
    // 订单查询计划
    if (this.$route.params.paramsObj) {
      const orderObj = this.$route.params.paramsObj
      this.projectOrder.routerParams.orderName = orderObj.orderName
      this.projectOrder.routerParams.orderId = orderObj.orderId
    }
    this.getSpaceList()
    this.getBaseDict()
    this.fetchData()
    this.fetchDataDebounced = debounce(this.fetchData, 500)
  }
}
</script>
<style lang="stylus" scoped>
.page-content
  padding 0 16px
.table-header-button.is-disabled, .table-header-button.is-disabled:hover
  color #D8D8D8
.table-header-button
  color #666
  border none !important
>>>.el-dialog--center .el-dialog__body
  text-align center
>>>.el-table-button-text
  color #1890FF
>>>.el-table-button-text.is-disabled
  color #C0C4CC
>>> .el-dropdown-menu__item:focus, .el-dropdown-menu__item:not(.is-disabled):hover
  background-color #ecf5ff
  color #1890FF
>>>.table-status
  display flex
  flex-direction row
  align-items center
.copy-form
  .el-input-number
    width 100%
  .lazy-select
    width 100%
</style>
